import type { TermsStatusResponse } from '../http/terms-status';

/** Pendente disparo de conversão (PostHog / GTM) após onboarding concluído. */
export const SIGNUP_PENDING_CONVERSION_KEY = 'wings_signup_pending_complete';

/** OAuth acabou de retornar nesta aba; usado para distinguir cadastro SSO de login recorrente. */
export const OAUTH_LOGIN_SESSION_KEY = 'wings_oauth_session_login';

export function markSignupPendingConversion(): void {
  try {
    sessionStorage.setItem(SIGNUP_PENDING_CONVERSION_KEY, '1');
  } catch {
    // ignore
  }
}

export function markOAuthLoginSession(): void {
  try {
    sessionStorage.setItem(OAUTH_LOGIN_SESSION_KEY, '1');
  } catch {
    // ignore
  }
}

export function clearSignupPendingConversion(): void {
  try {
    sessionStorage.removeItem(SIGNUP_PENDING_CONVERSION_KEY);
  } catch {
    // ignore
  }
}

/**
 * Após login OAuth, promove para conversão pendente só quando o gate de termos
 * é primeiro aceite (cadastro/onboarding), não reaceite por `requires_update`.
 */
export function syncSignupPendingAfterOAuthTermsCheck(
  terms: Pick<TermsStatusResponse, 'accepted' | 'requires_update'>,
): void {
  try {
    if (sessionStorage.getItem(OAUTH_LOGIN_SESSION_KEY) !== '1') {
      return;
    }
    sessionStorage.removeItem(OAUTH_LOGIN_SESSION_KEY);

    if (terms.requires_update === true) {
      return;
    }

    if (terms.accepted !== true) {
      sessionStorage.setItem(SIGNUP_PENDING_CONVERSION_KEY, '1');
    }
  } catch {
    // ignore
  }
}

/** Reaceite de termos não deve contar como conversão de cadastro. */
export function invalidateSignupPendingOnTermsUpdate(
  requiresUpdate: boolean,
): void {
  if (!requiresUpdate) {
    return;
  }
  clearSignupPendingConversion();
}

export function consumeSignupPendingConversion(): boolean {
  try {
    if (sessionStorage.getItem(SIGNUP_PENDING_CONVERSION_KEY) !== '1') {
      return false;
    }
    sessionStorage.removeItem(SIGNUP_PENDING_CONVERSION_KEY);
    return true;
  } catch {
    return false;
  }
}
